<div class="d-flex flex-column justify-content-center m-step-wrapper1 container wrapper-get-code-component">
  <span>
    {{"otp.instructions-proceed"|translate}}
  </span>
  <span *ngIf="!isNewForm">
    {{"otp.instructions-proceed2"|translate}}
  </span>

  <form class="form-column" #fGetCodeOtp="ngForm" *ngIf="phones || isDevMode || isNewForm" novalidate
    [formGroup]="otpGetCodeForm" (submit)="nextStep()">

    <div *ngIf="!isNewForm" class="section phone-dropdown">
      <app-dplist-new [valueArr]='phones' formControlName="mobile" [asyncData]="false" tabindex="0"
        [atrrDropDownId]="'choosePhone'"></app-dplist-new>

      <label class="m-error text-center text-md-right"
        *ngIf="otpGetCodeForm.controls['mobile'].hasError('required') && isSubmitted">
        {{ 'otp.choose-phone' | translate }}</label>

      <label class="m-error text-center text-md-right"
        *ngIf="otpGetCodeForm.get('mobile').hasError('pattern') && isSubmitted">
        {{ 'otp.invalid-mobile' | translate }} </label>
    </div>

    <div class="section py-5">
      <input type="radio" class="app-input" formControlName="otpType" id="smsRadio" checked [value]="'sms'">
      <label for="smsRadio" tabindex="0" data-id="smsRadioLabel">{{"otp.get-code-sms"|translate}}</label>

      <input type="radio" class="app-input" formControlName="otpType" id="ivrRadio" [value]="'ivr'">
      <label for="ivrRadio" tabindex="0" data-id="ivrRadioLabel">{{"otp.get-code-ivr"|translate}}</label>
    </div>

    <div *ngIf="!isNewForm" class="section button-section">
      <button type="submit" class="app-button"
        [ngClass]="{'button-primary': otpGetCodeForm.valid, 'button-primary-disabled': !(otpGetCodeForm.valid)}">{{"otp.proceed-btn"|translate}}</button>
    </div>
    <div *ngIf="isNewForm  && otpService.phoneOk" class="section button-section">
      <button type="submit" class="app-button button-primary">{{"otp.proceed-btn"|translate}}</button>
    </div>

  </form>
</div>


// WEBPACK FOOTER //
// ./src/app/login/otp/get-code/get-code.component.html